module.exports = __webpack_public_path__ + "media/Synchron_aufgewühlt_panisch.a377a8bb.mp3";